import React from "react";
// mui
import { Button } from "@mui/material";
// mui icon
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import AddIcon from "@mui/icons-material/Add";

export const CreateDialogButton = ({ children }) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true) ;
  const handleClose = () => setOpen(false);

  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        ...child.props,
        open: open,
        handleClose: handleClose,
      });
    }
    return child;
  });

  return (
    <Button
      label="Create"
      variant="contained"
      color="primary"
      name="newrecord"
      startIcon={
        children[0] === "Add New User" ? <PersonAddAltIcon /> : <AddIcon />
      }
      disableRipple
      sx={{
        background: "#FFC107",
        color: "#0A0A0A",
        textTransform: "none",
        transition: "none !important",
        "&:hover": {
          backgroundColor: "#FFA000",
        }
      }}
      onClick={handleOpen}
    >
        {childrenWithProps}
    </Button>
  );
};
